<template>
  <el-dialog
    title="课卡修改详情"
    :visible.sync="isShow"
    width="30%"
  >
    <div v-loading="isLoading">
      <div v-if="updateInfo.administrator" class="dialog-item">
        <div class="dialog-item-title accent-color">申请人员：</div>
        <div class="flex-center">
          <v-avatar-nickname
            :value="updateInfo.administrator.avatar"
            :nickname="updateInfo.administrator.nickname"
            :is-center="false"
          />
        </div>
      </div>

      <div v-if="updateInfo.old_student" class="dialog-item">
        <div class="dialog-item-title accent-color">所属学员：</div>
        <div class="flex-center">
          <v-avatar-nickname
            :value="updateInfo.old_student.selfie"
            :nickname="`${updateInfo.old_student.student_name}${updateInfo.old_student.is_del ? '（已注销）' : ''}`"
            :is-center="false"
            :link-page-name="studentDetailPageName"
            :link-page-id="updateInfo.old_student.id"
          />
        </div>
        <div
          v-if="updateInfo.student && updateInfo.old_student.id !== updateInfo.student.id"
          class="flex-center"
        >
          <v-icon name="arrow-right"/>
          <div class="flex-center">
            <v-avatar-nickname
              :value="updateInfo.student.selfie"
              :nickname="`${updateInfo.student.student_name}${updateInfo.student.is_del ? '（已注销）' : ''}`"
              :is-center="false"
              :link-page-name="studentDetailPageName"
              :link-page-id="updateInfo.student.id"
            />
          </div>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">办卡日期：</div>
        <span>{{ updateInfo.old_register_time | timeToYmd }}</span>
        <div class="flex-center" v-if="updateInfo.old_register_time !== updateInfo.register_time">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.register_time | timeToYmd }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">办卡门店：</div>
        <span>{{ updateInfo.store_name }}</span>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">课卡名称：</div>
        <span>{{ updateInfo.old_card_name }}</span>
        <div class="flex-center" v-if="updateInfo.old_card_name !== updateInfo.card_name">
          <i class="icon-arrow-right"/>
          <span class="primary-color">{{ updateInfo.card_name }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">课卡类型：</div>
        <span>{{ updateInfo.old_card_type_name }}</span>
        <div class="flex-center" v-if="updateInfo.old_card_type_name !== updateInfo.card_type_name">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.card_type_name }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">适用门店：</div>
        <span>{{ updateInfo.old_store_names || '全国通用' }}</span>
        <div class="flex-center" v-if="updateInfo.old_store_names !== updateInfo.store_names">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.store_names || '全国通用' }}</span>
        </div>
      </div>

      <template v-if="updateInfo.store_names">
        <div class="dialog-item">
          <div class="dialog-item-title accent-color">适用门店限制天数：</div>
          <span>{{ updateInfo.old_store_limit_expire_days }} 天</span>
          <div class="flex-center" v-if="updateInfo.old_store_limit_expire_days !== updateInfo.store_limit_expire_days">
            <v-icon name="arrow-right"/>
            <span class="primary-color">{{ updateInfo.store_limit_expire_days }} 天</span>
          </div>
        </div>

        <div class="dialog-item">
          <div class="dialog-item-title accent-color">适用门店失效日期：</div>
          <span>{{ updateInfo.old_store_limit_expire_time | timeToYmdHi }}</span>
          <div class="flex-center" v-if="updateInfo.old_store_limit_expire_time !== updateInfo.store_limit_expire_time">
            <v-icon name="arrow-right"/>
            <span class="primary-color">{{ updateInfo.store_limit_expire_time | timeToYmdHi }}</span>
          </div>
        </div>
      </template>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">次数限定：</div>
        <span>{{ updateInfo.old_is_number_limit ? '是' : '否' }}</span>
        <div
          class="flex-center"
          v-if="updateInfo.old_is_number_limit !== updateInfo.is_number_limit"
        >
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.is_number_limit ? '是' : '否' }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">剩余次数：</div>
        <span>{{ updateInfo.old_expire_number | toYuan }} 次</span>
        <div class="flex-center" v-if="updateInfo.old_expire_number !== updateInfo.expire_number">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.expire_number | toYuan }} 次</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">有效天数：</div>
        <span>{{ updateInfo.old_expire_days }} 天</span>
        <div class="flex-center" v-if="updateInfo.old_expire_days !== updateInfo.expire_days">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.expire_days }} 天</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">过期时间：</div>
        <span>{{ updateInfo.old_expire_time | timeToYmdHi }}</span>
        <div class="flex-center" v-if="updateInfo.old_expire_time !== updateInfo.expire_time">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.expire_time | timeToYmdHi }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">付款方式：</div>
        <span>{{ updateInfo.old_card_payment_mode_name }}</span>
        <div
          class="flex-center"
          v-if="updateInfo.old_card_payment_mode_name !== updateInfo.card_payment_mode_name"
        >
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.card_payment_mode_name }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">付款凭证：</div>
        <div class="flex-center">
          <v-img v-if="updateInfo.old_receipt" :value="updateInfo.old_receipt"/>
          <template v-else>无</template>
        </div>
        <div
          v-if="updateInfo.old_receipt !== updateInfo.receipt"
          class="flex-center"
        >
          <v-icon name="arrow-right"/>
          <div class="flex-center">
            <v-img class="receipt" :value="updateInfo.receipt"/>
          </div>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">有赞券码：</div>
        <span>{{ updateInfo.old_you_zan_number }}</span>
        <div
          class="flex-center"
          v-if="updateInfo.old_you_zan_number !== updateInfo.you_zan_number"
        >
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.you_zan_number }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">实际付款：</div>
        <span>{{ updateInfo.old_actual_payment | toYuan }} 元</span>
        <div class="flex-center" v-if="updateInfo.old_actual_payment !== updateInfo.actual_payment">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.actual_payment | toYuan }} 元</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">付款备注：</div>
        <span>{{ updateInfo.old_payment_remark }}</span>
        <div class="flex-center" v-if="updateInfo.old_payment_remark !== updateInfo.payment_remark">
          <v-icon name="arrow-right"/>
          <span class="primary-color">{{ updateInfo.payment_remark }}</span>
        </div>
      </div>

      <div class="dialog-item">
        <div class="dialog-item-title accent-color">所补差价：</div>
        <span class="primary-color">{{ updateInfo.update_payment | toYuan }} 元</span>
      </div>

      <div v-if="updateInfo.update_remark" class="dialog-item">
        <div class="dialog-item-title accent-color">修改原因：</div>
        <span class="primary-color">{{ updateInfo.update_remark }}</span>
      </div>

      <div class="dialog-footer">
        <el-button class="footer-button" @click="$emit('back')">返 回</el-button>

        <template v-if="updateInfo.update_state === updateStates.review.value">
          <template v-if="isAdministrator">
            <el-popover v-model="updateInfo.showRejectTip" placement="top" class="footer-button">
              <p>确认要驳回申请吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" @click="updateInfo.showRejectTip = false">取消</el-button>
                <el-button type="primary" size="mini" @click="$emit('reject', updateInfo)">
                  确认
                </el-button>
              </div>
              <el-button
                :loading="isRejectingIds.includes(updateInfo.id)"
                :disabled="isPassingIds.includes(updateInfo.id)"
                slot="reference"
                type="danger"
              >
                驳回申请
              </el-button>
            </el-popover>

            <el-popover v-model="updateInfo.showPassTip" placement="top">
              <p>确认要通过申请吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" @click="updateInfo.showPassTip = false">取消</el-button>
                <el-button type="primary" size="mini" @click="$emit('pass', updateInfo)">
                  确认
                </el-button>
              </div>
              <el-button
                :loading="isPassingIds.includes(updateInfo.id)"
                :disabled="isRejectingIds.includes(updateInfo.id)"
                slot="reference"
                type="success"
              >
                通过申请
              </el-button>
            </el-popover>
          </template>

          <el-popover
            v-else
            v-model="updateInfo.showRevokeTip"
            placement="top"
          >
            <p>确认要撤销申请吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" @click="updateInfo.showRevokeTip = false">取消</el-button>
              <el-button type="primary" size="mini" @click="handleRevoke">确认</el-button>
            </div>
            <el-button
              :loading="isRevokingIds.includes(updateInfo.id)"
              slot="reference"
              type="danger"
            >
              撤销申请
            </el-button>
          </el-popover>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import updateStates from '@/enums/cardUpdateStates';
import RouteConfig from "@/router/config";

export default {
  props: {
    value: Boolean,
    isLoading: Boolean,
    updateInfo: Object,
    isPassingIds: Array,
    isRejectingIds: Array,
    isRevokingIds: Array,
  },
  watch: {
    value(value) {
      if (value !== this.isShow) this.isShow = value;
    },
    isShow(isShow) {
      if (isShow !== this.value) this.$emit('input');
    },
  },
  data: () => ({
    isShow: false,
    studentDetailPageName: RouteConfig.studentDetail.name,
    updateStates,
  }),
  computed: {
    isAdministrator() {
      return this.$store.getters.isAdministrator;
    },
  },
  methods: {
    handleRevoke() {
      this.updateInfo.showRevokeTip = false;
      this.$emit('revoke', this.updateInfo);
    },
  }
};
</script>

<style src="./index.css" scoped/>
